// extracted by mini-css-extract-plugin
export default {"container":"ButtonGenerate_container__TYQXZ","button--text":"ButtonGenerate_button--text__V1SoW","style--generate":"ButtonGenerate_style--generate__FC12M"};